import React, { memo, useEffect, useState } from 'react';
import { StructuredGraph as StructuredGraphType } from '../../Dto/chatbotStructuredResponse';
import ChartRenderer from './ChartRenderer';
import './StructuredComponents.css';

interface StructuredGraphProps {
  graph: StructuredGraphType;
  isMobile?: boolean;
  isExpanded?: boolean;
}

const StructuredGraph: React.FC<StructuredGraphProps> = ({ 
  graph, 
  isMobile = false, 
  isExpanded = false 
}) => {
  const [chartKey, setChartKey] = useState(0);
  
  useEffect(() => {
    // Force chart re-render when expand state changes
    setChartKey(prev => prev + 1);
  }, [isExpanded]);
  
  // Validate graph has data - check for null, missing data, or empty series array
  if (!graph || !graph.data || !graph.data.series || !Array.isArray(graph.data.series) || graph.data.series.length === 0) {
    return null;
  }

  const height = isMobile ? 280 : isExpanded ? Math.min(window.innerHeight * 0.6, 600) : 320;

  return (
    <div className={`chatbot-structured-graph-container ${isMobile ? 'mobile' : ''}`}>
      <ChartRenderer
        key={chartKey}
        type={graph.type}
        title={graph.title}
        data={graph.data}
        height={height}
      />
    </div>
  );
};

export default memo(StructuredGraph);
